import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'envc-social-media',
  styleUrl: 'envc-social-media.scss',
})
export class EnvcSocialMedia {
  @Prop() headline: string;

  render() {
    return (
      <section data-tpl="fol01">
        {(this.headline) && (
          <div class="headline h6">{this.headline}</div>
        )}

        <ul>
          <slot></slot>
        </ul>
      </section>
    );
  }
}
